export const categories = [
  {
    id: 'historic-sites',
    title: 'Historic Sites',
    description: 'Explore Jamaica\'s rich history through its most significant historic sites and landmarks.',
    icon: 'landmark',
    subcategories: [
      {
        id: 'plantation-houses',
        title: 'Plantation Houses & Great Houses',
        items: [
          { id: 'rose-hall', name: 'Rose Hall Great House', location: 'Montego Bay', rating: 4.3 },
          { id: 'devon-house', name: 'Devon House', location: 'Kingston', rating: 4.4 },
          { id: 'good-hope', name: 'Good Hope Plantation', location: 'Trelawny', rating: 4.2 },
          { id: 'firefly', name: 'Firefly Estate', location: 'Port Maria', rating: 4.1 }
        ]
      },
      {
        id: 'museums',
        title: 'Museums & Cultural Centers',
        items: [
          { id: 'bob-marley', name: 'Bob Marley Museum', location: 'Kingston', rating: 4.3 },
          { id: 'trench-town', name: 'Trench Town Culture Yard', location: 'Kingston', rating: 4.0 },
          { id: 'peter-tosh', name: 'Peter Tosh Museum', location: 'Kingston', rating: 4.2 },
          { id: 'national-gallery', name: 'National Gallery', location: 'Kingston', rating: 4.0 }
        ]
      },
      {
        id: 'landmarks',
        title: 'Historic Landmarks',
        items: [
          { id: 'port-royal', name: 'Port Royal', location: 'Kingston', rating: 4.1 },
          { id: 'fort-charles', name: 'Fort Charles', location: 'Port Royal', rating: 4.0 },
          { id: 'seville-heritage', name: 'Seville Heritage Park', location: 'St. Ann', rating: 3.9 },
          { id: 'spanish-town', name: 'Spanish Town Historic District', location: 'Spanish Town', rating: 3.8 }
        ]
      }
    ]
  },
  {
    id: 'restaurants',
    title: 'Restaurants',
    description: 'Discover Jamaica\'s culinary delights from authentic jerk spots to fine dining experiences.',
    icon: 'utensils',
    subcategories: [
      {
        id: 'authentic-jamaican',
        title: 'Authentic Jamaican Restaurants',
        items: [
          { id: 'scotchies', name: 'Scotchies', location: 'Montego Bay', rating: 4.5 },
          { id: 'miss-t', name: 'Miss T\'s Kitchen', location: 'Ocho Rios', rating: 4.4 },
          { id: 'juicy-patties', name: 'Juicy Patties', location: 'Multiple Locations', rating: 4.2 },
          { id: 'kool-vybes', name: 'Kool Vybes Bar & Jerk Centre', location: 'Negril', rating: 4.3 }
        ]
      },
      {
        id: 'fine-dining',
        title: 'Fine Dining & International Cuisine',
        items: [
          { id: 'stush-bush', name: 'Stush in the Bush', location: 'Free Hill', rating: 4.7 },
          { id: 'pelican-grill', name: 'The Pelican Grill', location: 'Montego Bay', rating: 4.3 },
          { id: 'saffron', name: 'Saffron Indian Restaurant', location: 'Kingston', rating: 4.4 },
          { id: 'eits-cafe', name: 'EITS Café', location: 'Newcastle', rating: 4.5 }
        ]
      },
      {
        id: 'seafood',
        title: 'Seafood Restaurants',
        items: [
          { id: 'aunt-may', name: 'Aunt May\'s Fish Place', location: 'Hellshire', rating: 4.4 },
          { id: 'little-ochie', name: 'Little Ochie Seafood', location: 'Alligator Pond', rating: 4.6 },
          { id: 'gloria-seafood', name: 'Gloria\'s Seafood', location: 'Port Royal', rating: 4.3 },
          { id: 'fisherman-point', name: 'Fisherman\'s Point', location: 'Ocho Rios', rating: 4.2 }
        ]
      }
    ]
  },
  {
    id: 'pet-services',
    title: 'Pet Services',
    description: 'Find the best care for your pets with top-rated groomers and veterinarians across Jamaica.',
    icon: 'paw',
    subcategories: [
      {
        id: 'pet-groomers',
        title: 'Pet Groomers',
        items: [
          { id: 'island-mobile', name: 'Island Mobile Vets & Grooming', location: 'Mobile Service', rating: 4.6 },
          { id: 'noahs-ark', name: 'Noah\'s Ark Veterinary Centre', location: 'Kingston', rating: 4.5 },
          { id: 'animalcare', name: 'Animalcare Portmore', location: 'Portmore', rating: 4.3 },
          { id: 'harris-pet', name: 'Harris Pet Ambulance & Grooming', location: 'Mobile Service', rating: 4.4 }
        ]
      },
      {
        id: 'veterinarians',
        title: 'Veterinary Clinics',
        items: [
          { id: 'dr-anderson', name: 'Dr. Ian G. Anderson', location: 'St. Ann', rating: 4.5 },
          { id: 'riverside', name: 'Riverside Veterinary Hospital', location: 'Mandeville', rating: 4.4 },
          { id: 'allpets', name: 'AllPets Veterinary Clinic', location: 'Kingston', rating: 4.6 },
          { id: 'paws4pets', name: 'Paws4Pets Veterinary Services', location: 'Montego Bay', rating: 4.3 }
        ]
      }
    ]
  },
  {
    id: 'marinas',
    title: 'Marinas & Yacht Clubs',
    description: 'Explore Jamaica\'s premier marinas and yacht clubs for boating enthusiasts and sailors.',
    icon: 'anchor',
    subcategories: [
      {
        id: 'yacht-clubs',
        title: 'Yacht Clubs',
        items: [
          { id: 'montego-bay-yacht', name: 'Montego Bay Yacht Club', location: 'Montego Bay', rating: 4.4 },
          { id: 'royal-jamaica', name: 'Royal Jamaica Yacht Club', location: 'Kingston', rating: 4.2 },
          { id: 'negril-yacht', name: 'Negril Yacht Club', location: 'Negril', rating: 4.0 },
          { id: 'port-royal-yacht', name: 'Grand Port Royal Hotel Yacht Club', location: 'Port Royal', rating: 3.9 }
        ]
      },
      {
        id: 'marinas-facilities',
        title: 'Marinas & Facilities',
        items: [
          { id: 'errol-flynn', name: 'Errol Flynn Marina', location: 'Port Antonio', rating: 4.0 },
          { id: 'port-antonio', name: 'Port Antonio Marina', location: 'Port Antonio', rating: 3.9 },
          { id: 'glistening-waters', name: 'Glistening Waters Marina', location: 'Falmouth', rating: 4.1 },
          { id: 'ocho-rios-port', name: 'Ocho Rios Cruise Port', location: 'Ocho Rios', rating: 3.8 }
        ]
      }
    ]
  },
  {
    id: 'golf-courses',
    title: 'Golf Courses',
    description: 'Tee off at Jamaica\'s world-class golf courses with stunning views and challenging play.',
    icon: 'golf-ball',
    subcategories: [
      {
        id: 'championship-courses',
        title: 'Championship Courses',
        items: [
          { id: 'white-witch', name: 'White Witch Golf Course', location: 'Montego Bay', rating: 4.6 },
          { id: 'cinnamon-hill', name: 'Cinnamon Hill Golf Course', location: 'Montego Bay', rating: 4.5 },
          { id: 'half-moon', name: 'Half Moon Golf Club', location: 'Montego Bay', rating: 4.7 },
          { id: 'tryall', name: 'Tryall Golf Course', location: 'Hanover', rating: 4.6 }
        ]
      },
      {
        id: 'resort-courses',
        title: 'Resort Courses',
        items: [
          { id: 'sandals-golf', name: 'Sandals Golf & Country Club', location: 'Ocho Rios', rating: 4.4 },
          { id: 'three-palms', name: 'Three Palms Ocean Course', location: 'Negril', rating: 4.3 },
          { id: 'negril-hills', name: 'Negril Hills Golf Club', location: 'Negril', rating: 4.2 },
          { id: 'caymanas', name: 'Caymanas Golf & Country Club', location: 'Kingston', rating: 4.1 }
        ]
      }
    ]
  },
  {
    id: 'tourist-attractions',
    title: 'Tourist Attractions',
    description: 'Experience Jamaica\'s most popular attractions from beaches to adventure activities.',
    icon: 'umbrella-beach',
    subcategories: [
      {
        id: 'beaches',
        title: 'Beaches & Water Activities',
        items: [
          { id: 'seven-mile', name: 'Seven Mile Beach', location: 'Negril', rating: 4.8 },
          { id: 'doctors-cave', name: 'Doctor\'s Cave Beach', location: 'Montego Bay', rating: 4.5 },
          { id: 'frenchman-cove', name: 'Frenchman\'s Cove', location: 'Port Antonio', rating: 4.6 },
          { id: 'boston-bay', name: 'Boston Bay Beach', location: 'Portland', rating: 4.4 }
        ]
      },
      {
        id: 'waterfalls',
        title: 'Waterfalls & Natural Wonders',
        items: [
          { id: 'dunns-river', name: 'Dunn\'s River Falls', location: 'Ocho Rios', rating: 4.7 },
          { id: 'ys-falls', name: 'YS Falls', location: 'St. Elizabeth', rating: 4.6 },
          { id: 'blue-hole', name: 'Blue Hole', location: 'Ocho Rios', rating: 4.5 },
          { id: 'reach-falls', name: 'Reach Falls', location: 'Portland', rating: 4.6 }
        ]
      },
      {
        id: 'adventure',
        title: 'Adventure Activities',
        items: [
          { id: 'mystic-mountain', name: 'Mystic Mountain', location: 'Ocho Rios', rating: 4.5 },
          { id: 'blue-mountain', name: 'Blue Mountain Peak Trail', location: 'Blue Mountains', rating: 4.7 },
          { id: 'ricks-cafe', name: 'Rick\'s Café', location: 'Negril', rating: 4.6 },
          { id: 'chukka-adventures', name: 'Chukka Caribbean Adventures', location: 'Multiple Locations', rating: 4.5 }
        ]
      }
    ]
  }
];

export const investorResources = {
  id: 'investor-resources',
  title: 'Investor Resources',
  description: 'Essential information for investors looking to do business in Jamaica.',
  sections: [
    {
      id: 'real-estate',
      title: 'Real Estate Opportunities',
      content: 'Information about residential and commercial property investment in Jamaica.'
    },
    {
      id: 'business-climate',
      title: 'Business Investment Climate',
      content: 'Overview of Jamaica\'s business environment, incentives, and growth sectors.'
    },
    {
      id: 'financial-services',
      title: 'Banking & Financial Services',
      content: 'Information about banking, financing options, and financial regulations in Jamaica.'
    },
    {
      id: 'legal-regulatory',
      title: 'Legal & Regulatory Information',
      content: 'Details about business laws, tax information, permits, and licenses required in Jamaica.'
    }
  ]
};

export const relocationGuide = {
  id: 'relocation-guide',
  title: 'Relocation Guide',
  description: 'Comprehensive information for those considering moving to Jamaica.',
  sections: [
    {
      id: 'visa-residency',
      title: 'Visa & Residency',
      content: 'Requirements and application process for long-term stays in Jamaica.'
    },
    {
      id: 'housing',
      title: 'Housing & Accommodation',
      content: 'Long-term rental options, purchase information, and neighborhood guides.'
    },
    {
      id: 'healthcare-education',
      title: 'Healthcare & Education',
      content: 'Information about hospitals, clinics, international schools, and educational institutions.'
    },
    {
      id: 'daily-life',
      title: 'Daily Life',
      content: 'Practical information about utilities, transportation, shopping, and safety in Jamaica.'
    }
  ]
};
